import apiClient from "./config"
import { INVESTMENT_ENDPOINTS } from "./endpoints"

const investmentService = {
    viewInvestmentReport: (payload) => {
        return apiClient.post(INVESTMENT_ENDPOINTS.VIEW_INVESTMENT_REPORT, payload)
    },
    viewInvestmentInputs: (payload) => {
        return apiClient.post(INVESTMENT_ENDPOINTS.VIEW_INVESTMENT_INPUTS, payload)
    }
}

export default investmentService;